import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeSv from '@angular/common/locales/sv'
import {ApplicationConfig, inject, LOCALE_ID, provideAppInitializer} from '@angular/core'
import {LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {ADMIN_ROLE, LOCAL_STORAGE, READ_ONLY_ROLE, REGISTRAR_ROLE_NAME} from './application/app'

registerLocaleData(localeSv, 'sv')
const configServiceConfig: IConfig = {
  authServiceUrl: environment.commonServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE, REGISTRAR_ROLE_NAME, READ_ONLY_ROLE]
}
export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'För att komma igång behöver du först logga in med ditt BankID',
        buttonText: 'Logga in med BankID',
        title: ''
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: LOCAL_STORAGE,
      useFactory: () => localStorage
    },
    {provide: MAT_DATE_LOCALE, useValue: 'sv-SE'},
    {provide: LOCALE_ID, useValue: 'sv-SE'},
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true, firstDayOfWeek: 1}
    },
    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])
    ),
    provideRouter(
      routes,
      withHashLocation(),
      withInMemoryScrolling({anchorScrolling: 'enabled'})
    ),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        subscriptSizing: 'dynamic',
        hideRequiredMarker: true, appearance: 'outline'
      }
    },
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv}
  ]
}